import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

/**
 * Componente de callback do Azure AD
 * Processa o retorno da autenticação por redirect (MSAL) e troca o token
 * pelo cookie HTTP-Only no backend antes de redirecionar ao dashboard.
 */
export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Garantia contra dupla execução (React 18 StrictMode em dev)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      try {
        console.log('Processing Azure AD callback...');

        // login() chama authService.login(), que internamente:
        //  1. Chama initializeMsal() → handleRedirectPromise() processa o auth code
        //  2. Faz acquireTokenSilent() com a conta recém-autenticada
        //  3. Chama exchangeTokenForCookie() → cria o cookie HTTP-Only no backend
        await login();

        console.log('Authentication successful, redirecting to dashboard');
        navigate('/dashboard', { replace: true });
      } catch (error) {
        // acquireTokenRedirect() lança uma exceção após redirecionar o browser;
        // não fazer nada nesse caso pois o redirect já está em progresso.
        const isRedirecting =
          error instanceof Error && error.message.includes('Redirecionando');

        if (!isRedirecting) {
          console.error('Error in auth callback:', error);
          navigate('/login', { replace: true });
        }
      }
    };

    handleCallback();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-xl flex items-center justify-center mx-auto mb-4">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
        </div>
        <h2 className="text-xl font-semibold text-slate-700 mb-2">
          Processando autenticação...
        </h2>
        <p className="text-slate-500">
          Finalizando login com Microsoft
        </p>
      </div>
    </div>
  );
};